import * as React from 'react';
import {Trans} from '@lingui/react';
import cl from 'classnames';

import SkillupLogo from '@components/Icons/SkillupLogo';

import {getSuffix} from '@services/utilities';

import s from './SSOLogoutPage.css';

export default function ErrorPage() {
  return (
    <div className={cl(s.LoginPage)}>
      <SkillupLogo className={s.Logo} negative size="38px" />

      <p className={s.Welcome}>
        <Trans id="sso_logout" components={{0: <br />}}>
          Logout avvenuto correttamente.
          <br />
          Se desideri rientrare utilizza il link che hai ricevuto via email.
        </Trans>
      </p>
      <p className={s.Copyright}>{`Skillup © ${new Date().getFullYear()} ${getSuffix()}`}</p>
    </div>
  );
}
